import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="ui--breadcrumbs-collapse"
//
// Mounted by Ui::BreadcrumbsComponent with `collapse_on_mobile: true`
// (CONEK-8179). Below sm the trail renders as "… › parent › current"; the
// CSS reads `data-expanded` on the <nav> (Tailwind `group-data-[expanded=true]`)
// to show the hidden items and hide the "…" trigger, so this controller only
// flips that attribute — it never touches design-system classes.
//
// connect() resets to collapsed, so a Turbo cache snapshot taken while the
// trail was expanded comes back collapsed.
export default class extends Controller {
  static targets = ["trigger"]

  connect() {
    delete this.element.dataset.expanded
    if (this.hasTriggerTarget) this.triggerTarget.setAttribute("aria-expanded", "false")
  }

  expand(event) {
    event?.preventDefault()
    this.element.dataset.expanded = "true"
    if (this.hasTriggerTarget) this.triggerTarget.setAttribute("aria-expanded", "true")

    // The trigger hides itself once expanded, so hand focus to the first crumb
    // instead of dropping it on <body>.
    const firstLink = this.element.querySelector("a[href]")
    if (firstLink instanceof HTMLElement) firstLink.focus()
  }
}
